import AppShell from './app/AppShell';
import type { ResolvedDependencies } from './app/dependencies';
import { ORDER_PATHS, RouterProvider } from './router';

export type AppProps = {
  dependencies: ResolvedDependencies;
};

export default function App({ dependencies }: AppProps) {
  return (
    <RouterProvider initialPath={ORDER_PATHS.setup}>
      <AppShell {...dependencies} />
    </RouterProvider>
  );
}
